import * as React from 'react';

import { SelectionCard } from 'src/components/dataSourceSelection/SelectionCard';
import { DataSourceIcon } from 'src/components/resourceDialog/DataSourceIcon';
import { getDataSourceTypeCardTestId } from 'src/constants/testIds';
import { connectionSelector } from 'src/selectors/connection';
import { dataSourceLabelsByTypeSelector } from 'src/selectors/dataSourceLabelsByType';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export type DataSourceTypeCardProps = {
  dataSourceType: string;
  disabledTooltip?: string;
  isLoading?: boolean;
  onClick: () => void;
};

export const DataSourceTypeCard: React.VFC<DataSourceTypeCardProps> = ({
  dataSourceType,
  disabledTooltip,
  isLoading = false,
  onClick,
}) => {
  const connection = useReduxSelector(connectionSelector);
  const dataSourceLabelsByType = useReduxSelector(
    dataSourceLabelsByTypeSelector(connection)
  );

  const label = dataSourceLabelsByType[dataSourceType] || dataSourceType;

  const icon = (
    <DataSourceIcon altText={`${label} icon`} dataSourceType={dataSourceType} />
  );

  return (
    <SelectionCard
      disabled={Boolean(disabledTooltip)}
      disabledTooltip={disabledTooltip}
      icon={icon}
      isLoading={isLoading}
      label={label}
      onSelect={onClick}
      testId={getDataSourceTypeCardTestId(dataSourceType)}
    />
  );
};
